module.exports = __webpack_public_path__ + "static/world-trade-organization-70d8bae37313bdc67ef7d9550ea056e4.svg";